import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.bubble.css';



// Helper to get grid columns class based on style
function getGridColsClass(style) {
    switch (style) {
        case '2-columns':
            return 'grid-cols-2';
        case '3-columns':
            return 'grid-cols-3';
        case '4-columns':
            return 'grid-cols-4';
        case 'list':
        default:
            return 'flex flex-col gap-3';
    }
}

export default function BlockQuiz({ block, className, goToStep, settingsFunnel }) {
    // Fallback options if none provided 

 
   if(block.options === undefined){
        block.options = [
            {
                id: 'option-' + uuidv4(),
                img: block.img? block.img : "",
                content: "Escolha um",
               
                destinationType: "step",
                target: null,
            },
            {
                id: 'option-' + uuidv4(),
                img: block.img? block.img : "",
                content: "Escolha dois",
               
                destinationType: "step",
                target: null,
            }
        ];
        
    
    }
  

    
    const selectedOptions = [];


    if(block.showCheckBox === undefined){
        block.showCheckBox = true;
    } 

    // Style: 'list', '2-columns', '3-columns', '4-columns'
    const columns = block.columns || 'list';

    // For controlled checkboxes, you might want to lift state up in a real app
    const [selected, setSelected] = React.useState(
        block.options?.reduce((acc, opt, idx) => {
            acc[opt.id] = !!opt.checked;
            return acc;
        }, {}) || {}
    );

    const handleToggle = idx => {
            setSelected(sel => {
                const copy = {...sel};
                copy[idx] = !copy[idx];
                return copy;
            });
    };

     
    const handleClick = (e, option) => {
        e.preventDefault();
        
        // Toggle the selected state
        setSelected(sel => {
            const copy = {...sel};
            copy[option.id] = !copy[option.id];
            return copy;
        });

        // Handle checkbox state
        const checkbox = document.getElementById(`checkbox-${option.id}`);
        if (checkbox) {
            checkbox.checked = !selected[option.id];
        }

        // Handle navigation after a short delay if needed
        if (option.destinationType === 'step' && option.target !== null) {
            setTimeout(() => { 
                goToStep(option);
            }, 250);
        }
    };

    // Layout classes
    const gridClass =
        columns === 'list'
            ? 'flex flex-col  '
            : `grid  ${getGridColsClass(columns)}`;

    // Sorting logic for order: 'img-content' or 'content-img'
    // For 'list' style, determines if image comes before or after content
    const order = block.order || 'img-content';

    let bgColor = 'transparent';
    let borderColor = '1px solid #e0e0e0';
    let textColor = settingsFunnel.textColor;

    if(block.style === 'light'){
        bgColor = 'white';
        borderColor = '1px solid #e0e0e0';
        textColor = settingsFunnel.textColor;
    }else if(block.style === 'highlight'){
        bgColor = settingsFunnel.primaryColor;
        borderColor = '';
        textColor = settingsFunnel.buttonTextColor;
    }else{
        bgColor = 'transparent';
        borderColor = '1px solid #e0e0e0';
        textColor = settingsFunnel.textColor;
    }


    return (
        <div className={`rounded-xl   w-full ${className || ''}`}>
            <div className={gridClass}>
                {block.options?.map((opt, idx) => {
                    // If style is not 'list', use column layout (image on top, content below)
                    
                    if (columns !== 'list') {
                        return (
                            <div key={opt.id} className={`mx-2 rounded-lg` } 
                                style={{   
                                    cursor: 'pointer', 
                                    transition: 'transform 0.6s cubic-bezier(.4,2,.6,1)', 
                                    marginBottom: `${settingsFunnel.spacing}px`, 
                                    backgroundColor: bgColor, 
                                    border: borderColor,
                                    transform: selected[opt.id] ? 'scale(0.93)' : 'scale(1)'
                                }}
                                onClick={e => { 
                                    handleClick(e, opt);
                                }}
                            >
                            <label
                                key={opt.id}
                                className={`flex flex-col items-center gap-2 ${selectedOptions.includes(opt.id) ? 'bg-blue-500' : ''} rounded-lg border border-gray-200    transition  cursor-pointer`}
                                style={{ minHeight: 70 }}
                            >
                                {opt.img ? (
                                    opt.img.includes("http") ? (
                                        <div className="flex items-center justify-center w-full p-0 m-0 overflow-hidden" >
                                            <img src={opt.img} className="w-full rounded object-cover m-0 p-0 hover:scale-110 transition-all duration-300" />
                                        </div>
                                    ) : (
                                        <div className="flex items-center justify-center m-3" style={{width: 60, height: 60}}>
                                            <span className="text-gray-400 text-2xl" style={{fontSize: 65}}>{opt.img}</span>
                                        </div>
                                    )
                                ) : null}

                                <div className="flex items-center justify-center p-3 m-2 w-full">
                                    <div className="w-full flex-1 flex items-center justify-center ">
                                        <div className="text-gray-800 text-left w-full" style={{ lineHeight: 1.2 }}>
                                                <ReactQuill
                                                    value={opt.content}
                                                    readOnly={true} 
                                                    style={{zIndex:20, color: textColor, fontFamily: settingsFunnel.font, fontWeight: 'bold', pointerEvents: 'none'}}
                                                    theme="bubble"
                                                />                                        </div>
                                    </div>
                                     
                                        <div className="flex items-center justify-center  " style={{ display: block.showCheckBox === true ? 'block' : 'none' }}>

                                        <input
                                            type="checkbox"
                                            className="w-6 h-6 accent-blue-500   "
                                            style={{transform: 'translateY(4px) translateX(-4px)', pointerEvents: 'none'}}
                                            id={`checkbox-${opt.id}`}
                                            checked={selected[opt.id] || false}
                                            readOnly
                                            
                                        />
                                    </div>
                                   
                            
                                </div>
                            </label>
                            </div>
                        );
                    } else {
                        // 'list' style: image/content side by side, with order support
                        return (
                            <div key={opt.id} onClick={e => handleClick(e, opt)} style={{ 
                                transform: selected[opt.id] ? 'scale(0.93)' : 'scale(1)', 
                                cursor: 'pointer', 
                                transition: 'transform 0.6s cubic-bezier(.4,2,.6,1)', 
                                backgroundColor: bgColor, 
                                border: borderColor, 
                                marginBottom: `${settingsFunnel.spacing}px`
                            }} className="rounded-lg">
                            <label
                                key={opt.id}
                                className={`flex items-center gap-3 ${selectedOptions.includes(opt.id) ? 'bg-blue-500' : ''} rounded-lg   shadow-sm transition   cursor-pointer`}
                                style={{ minHeight: 70 }}
                            >
                                {order === 'img-content' && opt.img ? (
                                    opt.img.includes("http") ? (
                                        <div className="flex items-center gap-3">
                                            <img src={opt.img} className="w-20 h-20 rounded object-cover" />
                                        </div>
                                    ) : (
                                        <div className="flex items-center gap-3 m-3" style={{width: 50, height: 50}}>
                                            <span className="text-gray-400 text-2xl" style={{fontSize: 45}}>{opt.img}</span>
                                        </div>
                                    )
                                ) : null}
                                <div className="flex-1 p-3 " >
                                    <div className="text-gray-800   " style={{ lineHeight: 1.2, color: textColor }} >
                                        <ReactQuill
                                            value={opt.content}
                                            readOnly={true} 
                                            style={{zIndex:20, color: textColor, fontFamily: settingsFunnel.font, fontWeight: 'bold', pointerEvents: 'none'}}
                                            theme="bubble"
                                        />
                                    </div>
                                </div>
                                {order === 'content-img' && opt.img ? (
                                    opt.img.includes("http") ? (
                                        <div className="flex items-center gap-3">
                                            <img src={opt.img} className="w-10 h-10 rounded" />
                                        </div>
                                    ) : (
                                        <div className="flex items-center gap-3">
                                            <span className="text-gray-400 text-2xl">{opt.img}</span>
                                        </div>
                                    )
                                ) : null}
                              
                                    <div className="flex items-center justify-center p-2" style={{ display: block.showCheckBox === true ? 'block' : 'none' }}>

                                    <input
                                        type="checkbox"
                                        className="w-5 h-5  rounded-full" 
                                        id={`checkbox-${opt.id}`}
                                        checked={selected[opt.id] || false}
                                        readOnly
                                        style={{pointerEvents: 'none',}}
                                    />
                                    </div>
                               
                            </label>
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
}